/* diXed, Schieberknoepfe fuer den Instagram-Feed. Angelegt am 29.08.2026.

   Der Feed kommt aus einer fremden App und bringt keine Knoepfe mit. Dieses
   Skript haengt eine Leiste im selben Aufbau darunter, den Dawn fuer seine
   Schieber benutzt. Das Punkte-Skript erkennt sie daran und macht Punkte
   daraus.

   Seit 25.09.2026 fuer JEDES Widget der Seite (Warenkorb, 404, Suche, FAQ,
   Richtlinien), vorher nur fuer den Abschnitt der Startseite.

   Seit 13.10.2026 auch fuer den eigenen Feed (dixed-instagram-feed,
   [data-dx-ig-rolle]), der die App abloest. Die Zahl sichtbarer Kacheln wird
   gemessen statt fest auf 4 gesetzt: am Handy zeigt der eigene Feed zwei. */
(function () {
  var SICHTBAR_VORGABE = 4;

  function pfeil(richtung) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'slider-button slider-button--' + (richtung < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', richtung < 0 ? 'Nach links schieben' : 'Nach rechts schieben');
    b.innerHTML = '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false">'
      + '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293'
      + ' 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z"></path>'
      + '</svg></span>';
    return b;
  }

  function luecke(rolle) {
    var stil = getComputedStyle(rolle);
    return parseFloat(stil.columnGap || stil.gap || '0') || 0;
  }

  function breite(rolle) {
    var erste = rolle.firstElementChild;
    if (!erste) return 0;
    return erste.getBoundingClientRect().width + luecke(rolle);
  }

  /* Sichtbare Kacheln messen. Ist die Rolle (noch) nicht gezeichnet, gilt
     die alte Vorgabe von vier. */
  function sichtbar(rolle) {
    var s = breite(rolle);
    if (!s || !rolle.clientWidth) return SICHTBAR_VORGABE;
    return Math.max(1, Math.round((rolle.clientWidth + luecke(rolle)) / s));
  }

  function bauenFuer(rolle) {
    if (!rolle || rolle.getAttribute('data-dxig-leiste')) return;
    var kacheln = rolle.children.length;
    if (kacheln <= sichtbar(rolle)) return;
    rolle.setAttribute('data-dxig-leiste', '1');

    var seiten = kacheln - sichtbar(rolle) + 1;
    var leiste = document.createElement('div');
    leiste.className = 'slider-buttons dixed-ig-leiste';
    var links = pfeil(-1);
    var rechts = pfeil(1);
    var zaehler = document.createElement('div');
    zaehler.className = 'slider-counter caption';
    zaehler.innerHTML = '<span class="slider-counter--current">1</span>'
      + '<span aria-hidden="true"> / </span>'
      + '<span class="slider-counter--total">' + seiten + '</span>';
    leiste.appendChild(links);
    leiste.appendChild(zaehler);
    leiste.appendChild(rechts);
    rolle.parentNode.insertBefore(leiste, rolle.nextSibling);

    var jetzt = zaehler.querySelector('.slider-counter--current');

    function stand() {
      var s = breite(rolle);
      var i = s ? Math.round(rolle.scrollLeft / s) + 1 : 1;
      if (i < 1) i = 1;
      if (i > seiten) i = seiten;
      jetzt.textContent = String(i);
      links.disabled = i <= 1;
      rechts.disabled = i >= seiten;
    }

    links.addEventListener('click', function () { rolle.scrollBy({ left: -breite(rolle), behavior: 'smooth' }); });
    rechts.addEventListener('click', function () { rolle.scrollBy({ left: breite(rolle), behavior: 'smooth' }); });
    rolle.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand);
    stand();
  }

  function rollen() {
    return Array.prototype.slice.call(document.querySelectorAll('.gfa-content__grid-container, [data-dx-ig-rolle]'));
  }

  function bauen() {
    rollen().forEach(bauenFuer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bauen);
  } else {
    bauen();
  }
  /* Die App laedt ihre Kacheln teils nach. */
  window.addEventListener('load', bauen);
  var versuche = 0;
  var takt = setInterval(function () {
    versuche++;
    bauen();
    var alle = rollen();
    var fertig = alle.length > 0 && alle.every(function (r) {
      return r.getAttribute('data-dxig-leiste') || r.children.length <= sichtbar(r);
    });
    if (versuche > 20 || fertig) clearInterval(takt);
  }, 500);
})();
